import script from "./CreateDir.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDir.vue?vue&type=script&setup=true&lang=js"

import "./CreateDir.vue?vue&type=style&index=0&id=12c1ed1b&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c1ed1b"]])

export default __exports__